/**
 * Allows a given input-type element to listen for changes in other form elements,
 * concatenating the values ​​and set to its own value.
 *
 * Example:
 * <input type="text" data-for="example" />
 * <input type="text" data-for="example" />
 * <input type="hidden" id="example" v-input-listener />
 */
 const getEvent = (event) => {
  const isTouch = event.changedTouches && event.changedTouches[0]
  if (isTouch) {
    return isTouch
  } else {
    return event
  }
}

const checkThreshold = (Options) => {
  const { thresholdDirection, touchOffset, triggerCallback, threshold } = Options
  let triggerAction = false
  switch (thresholdDirection) {
    case 'left':
      if (touchOffset.x <= -threshold) {
        triggerAction = true
      }
      break
    case 'right':
      if (touchOffset.x >= threshold) {
        triggerAction = true
      }
      break
    case 'top':
      if (touchOffset.y <= -threshold) {
        triggerAction = true
      }
      break
    case 'bottom':
      if (touchOffset.y >= threshold) {
        triggerAction = true
      }
      break
  }
  if (triggerAction) {
    triggerCallback()
  }
}

const clear = (Options) => {
  const { touchStart, touchOffset } = Options
  touchStart.x = null
  touchStart.y = null
  touchOffset.x = 0
  touchOffset.y = 0
}

const tStart = ($event, Options) => {
  const { disableDrag, touchStart, tStartTransform, el } = Options
  if (disableDrag(document)) {
    return
  }
  el.classList.add('dragging')
  touchStart.y = getEvent($event).pageY
  touchStart.x = getEvent($event).pageX
  if (typeof tStartTransform === 'function') {
    tStartTransform(Options)
  }
}

const tMove = ($event, Options) => {
  const { disableDrag, touchStart, touchOffset, initialMove, tMoveTransform } = Options
  if (disableDrag(document)) {
    return
  }
  const xOffset = getEvent($event).pageX - touchStart.x
  const yOffset = getEvent($event).pageY - touchStart.y
  const isAboveInitialMoveThreshold = Math.abs(xOffset) > initialMove
    || Math.abs(yOffset) > initialMove
    || touchOffset.x
    || touchOffset.y
  if (
    touchStart.x !== null
    && touchStart.y !== null
    && isAboveInitialMoveThreshold
  ) {
    touchOffset.x = xOffset
    touchOffset.y = yOffset
    if (typeof tMoveTransform === 'function') {
      tMoveTransform(Options)
    }
  }
}

const tEnd = ($event, Options) => {
  const { disableDrag, touchStart, triggerCallback, thresholdDirection, initialMove, tEndTransform, el } = Options
  if (disableDrag(document)) {
    return
  }
  el.classList.remove('dragging')
  if (
    Math.abs(touchStart.y - getEvent($event).pageY) > initialMove
    || Math.abs(touchStart.x - getEvent($event).pageX) > initialMove
    || !touchStart.x
    || !touchStart.y
  ) {
    $event.preventDefault()
  }
  if (
    triggerCallback
    && thresholdDirection
    && typeof triggerCallback === 'function'
  ) {
    checkThreshold(Options)
  }
  clear(Options)
  if (typeof tEndTransform === 'function') {
    tEndTransform(Options)
  }
}
export const dragTrigger = {
  name: 'dragg-trigger',
  inserted: (el, bindings, vnode) => {
    const body = document.querySelector('body')
    if (!body.classList.contains('login')) {
      const {
        initialMove = 10,
        threshold = 50,
        triggerCallback = null,
        thresholdDirection = null,
        disableDrag = () => false,
        tMoveTransform = null,
        tStartTransform = null,
        tEndTransform = null
      } = bindings.value
      const Options = {
        el,
        initialMove,
        threshold,
        triggerCallback,
        thresholdDirection,
        disableDrag,
        tMoveTransform,
        tStartTransform,
        tEndTransform,
        touchStart: { x: null, y: null },
        touchOffset: { x: 0, y: 0 }
      }
      el.addEventListener('touchstart', (e) => tStart(e, Options))
      el.addEventListener('touchmove', (e) => tMove(e, Options))
      el.addEventListener('touchend', (e) => tEnd(e, Options))
    }
  },
  unbind: (el) => {
    el.removeEventListener('touchstart', (e) => tStart(e))
    el.removeEventListener('touchmove', (e) => tMove(e))
    el.removeEventListener('touchend', (e) => tEnd(e))
  }
}
